import Vue from 'vue';
import Router from 'vue-router';
import Layout_web from '@/layout_web/Layout';// PC端官网
import Layout_mobile from '@/layout_mobile/Layout';// 移动端官网

Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',//路径
      name:'PC',//命名
      component:Layout_web,//组件(布局组件)
      redirect:'/',//重定向
      children:[//子组件
        {// 首页
          path: "/",
          component: () => import("@/views/home")
        },
      ]
    },
    {// PC端
      path:'/pc',//路径
      name:'PC',//命名
      component:Layout_web,//组件(布局组件)
      children:[//子组件
        {// 联系我们
          path: "connect",
          component: () => import("@/views/connect")
        },
      ]
    },
    {// 移动端
      path:'/mobile',//路径
      name:'Mobile',//命名
      component:Layout_mobile,//组件(布局组件)
      redirect:{name:'home_mobile'},//重定向
      children:[//子组件
        {// 首页
          path: "/",
          name:'home_mobile',
          component: () => import("@/views/home_mobile")
        },
        {// 联系我们
          path: "connect",
          name:'connect_mobile',
          component: () => import("@/views/connect_mobile")
        }
      ]
    }
  ]
})
